import { faUser as falUser } from '@fortawesome/pro-light-svg-icons/faUser';
import { faUserEdit as falUserEdit } from '@fortawesome/pro-light-svg-icons/faUserEdit';
import { faInfoCircle as falInfoCircle } from '@fortawesome/pro-light-svg-icons/faInfoCircle';
import { faTrash as falTrash } from '@fortawesome/pro-light-svg-icons/faTrash';
import { faChevronUp as faChevronUp } from '@fortawesome/pro-light-svg-icons/faChevronUp';
import { faChevronDown as faChevronDown } from '@fortawesome/pro-light-svg-icons/faChevronDown';
import { faChevronLeft as faChevronLeft } from '@fortawesome/pro-light-svg-icons/faChevronLeft';
import { faChevronRight as faChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faSquare as falSquare } from '@fortawesome/pro-light-svg-icons/faSquare';
import { faCheckSquare as falSquareCheck } from '@fortawesome/pro-light-svg-icons/faCheckSquare';
import { faHospitalAlt as falInstitution } from '@fortawesome/pro-light-svg-icons/faHospitalAlt';
import { faSitemap as falTrialInstitution } from '@fortawesome/pro-light-svg-icons/faSitemap';
import { faDna as falTrial } from '@fortawesome/pro-light-svg-icons/faDna';
import { faCogs as falSettings } from '@fortawesome/pro-light-svg-icons/faCogs';
import { faIdCardAlt as falRole } from '@fortawesome/pro-light-svg-icons/faIdCardAlt';
import { faStickyNote as falNote } from '@fortawesome/pro-light-svg-icons/faStickyNote';
import { faSitemap as falGroup } from '@fortawesome/pro-light-svg-icons/faSitemap';
import { faClipboardList as falTrialItem } from '@fortawesome/pro-light-svg-icons/faClipboardList';
import { faList as falLookup } from '@fortawesome/pro-light-svg-icons/faList';
import { faObjectGroup as falItemCollection } from '@fortawesome/pro-light-svg-icons/faObjectGroup';
import { faEdit as falEdit } from '@fortawesome/pro-light-svg-icons/faEdit';
import { faEnvelope as faEnvelope } from '@fortawesome/pro-light-svg-icons/faEnvelope';
import { faHome as falHome } from '@fortawesome/pro-light-svg-icons/faHome';
import { faIdBadge as falIdBadge } from '@fortawesome/pro-light-svg-icons/faIdBadge';
import { faPaperclip as falPaperClip } from '@fortawesome/pro-light-svg-icons/faPaperclip';
import { faChevronRight as falChevronRight } from '@fortawesome/pro-light-svg-icons/faChevronRight';
import { faPenField as falPenField } from '@fortawesome/pro-light-svg-icons/faPenField';
import { faFileArrowDown as falFileArrowDown } from '@fortawesome/pro-light-svg-icons/faFileArrowDown';
import { faFileArrowUp as falFileArrowUp } from '@fortawesome/pro-light-svg-icons/faFileArrowUp';
import { faDash as falDash } from '@fortawesome/pro-light-svg-icons/faDash';

import { faUser as farUser } from '@fortawesome/pro-regular-svg-icons/faUser';
import { faUserEdit as farUserEdit } from '@fortawesome/pro-regular-svg-icons/faUserEdit';
import { faTimes as farTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { faCheck as farCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';
import { faQuestion as farQuestion } from '@fortawesome/pro-regular-svg-icons/faQuestion';
import { faHandPointRight as farHandPointRight } from '@fortawesome/pro-regular-svg-icons/faHandPointRight';
import { faSearch as farSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { faClock as farClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faTimesCircle as farTimesCircle } from '@fortawesome/pro-regular-svg-icons/faTimesCircle';
import { faStar as farStar } from '@fortawesome/pro-regular-svg-icons/faStar';
import { faTag as farTag } from '@fortawesome/pro-regular-svg-icons/faTag';
import { faClipboard as farClipboard } from '@fortawesome/pro-regular-svg-icons/faClipboard';
import { faRepeat as farRepeat } from '@fortawesome/pro-regular-svg-icons/faRepeat';

import { faUser as fasUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faUserEdit as fasUserEdit } from '@fortawesome/pro-solid-svg-icons/faUserEdit';
import { faCircle as fasCircle } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faQuestion as fasQuestion } from '@fortawesome/pro-solid-svg-icons/faQuestion';
import { faSquare as fasSquare } from '@fortawesome/pro-solid-svg-icons/faSquare';
import { faAngleUp as fasAngleUp } from '@fortawesome/pro-solid-svg-icons/faAngleUp';
import { faAngleDown as fasAngleDown } from '@fortawesome/pro-solid-svg-icons/faAngleDown';
import { faAngleRight as fasAngleRight } from '@fortawesome/pro-solid-svg-icons/faAngleRight';
import { faAngleLeft as fasAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faBuilding as fasBuilding } from '@fortawesome/pro-solid-svg-icons/faBuilding';
import { faInfoSquare as fasInfoSquare } from '@fortawesome/pro-solid-svg-icons/faInfoSquare';
import { faInfoCircle as fasInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { faFileAlt as fasFileAlt } from '@fortawesome/pro-solid-svg-icons/faFileAlt';
import { faFile as fasFile } from '@fortawesome/pro-solid-svg-icons/faFile';
import { faCalendarAlt as fasCalendarAlt } from '@fortawesome/pro-solid-svg-icons/faCalendarAlt';
import { faMedkit as fasMedKit } from '@fortawesome/pro-solid-svg-icons/faMedkit';
import { faExclamationCircle as fasExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faExclamationTriangle as fasExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import { faTimesOctagon as fasTimesOctagon } from '@fortawesome/pro-solid-svg-icons/faTimesOctagon';
import { faCheck as fasCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faTruck as fasTruck } from '@fortawesome/pro-solid-svg-icons/faTruck';
import { faClipboard as fasClipboard } from '@fortawesome/pro-solid-svg-icons/faClipboard';
import { faHeartbeat as fasHeartbeat } from '@fortawesome/pro-solid-svg-icons/faHeartbeat';
import { faFlask as fasFlask } from '@fortawesome/pro-solid-svg-icons/faFlask';
import { faPlus as fasPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faSignIn as fasSignIn } from '@fortawesome/pro-solid-svg-icons/faSignIn';
import { faSignOut as fasSignOut } from '@fortawesome/pro-solid-svg-icons/faSignOut';
import { faVial as fasVial } from '@fortawesome/pro-solid-svg-icons/faVial';
import { faVials as fasVials } from '@fortawesome/pro-solid-svg-icons/faVials';
import { faCloudUpload as fasCloudUpload } from '@fortawesome/pro-solid-svg-icons/faCloudUpload';
import { faCloudDownload as fasCloudDownload } from '@fortawesome/pro-solid-svg-icons/faCloudDownload';
import { faSearch as fasSearch } from '@fortawesome/pro-solid-svg-icons/faSearch';
import { faBan as fasBan } from '@fortawesome/pro-solid-svg-icons/faBan';
import { faList as fasList } from '@fortawesome/pro-solid-svg-icons/faList';
import { faCogs as fasCogs } from '@fortawesome/pro-solid-svg-icons/faCogs';
import { faEye as fasEye } from '@fortawesome/pro-solid-svg-icons/faEye';
import { faAsterisk as fasAsterisk } from '@fortawesome/pro-solid-svg-icons/faAsterisk';
import { faBars as fasHamburger } from '@fortawesome/pro-solid-svg-icons/faBars';
import { faCog as fasCog } from '@fortawesome/pro-solid-svg-icons/faCog';
import { faProjectDiagram as fasProjectDiagram } from '@fortawesome/pro-solid-svg-icons/faProjectDiagram';
import { faDna as fasTrial } from '@fortawesome/pro-solid-svg-icons/faDna';
import { faUsers as fasGroup } from '@fortawesome/pro-solid-svg-icons/faUsers';
import { faHospitalAlt as fasInstitution } from '@fortawesome/pro-solid-svg-icons/faHospitalAlt';
import { faFileMedicalAlt as fasQa } from '@fortawesome/pro-solid-svg-icons/faFileMedicalAlt';
import { faIdCardAlt as fasOpenClinica } from '@fortawesome/pro-solid-svg-icons/faIdCardAlt';
import { faChevronRight as fasChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronLeft as fasChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faTriangle as fasTriangle } from '@fortawesome/pro-solid-svg-icons/faTriangle';
import { faCaretDown as fasCaretDown } from '@fortawesome/pro-solid-svg-icons/faCaretDown';
import { faDash as fasDash } from '@fortawesome/pro-solid-svg-icons/faDash';

import { faCircleUser as fadCircleUser } from '@fortawesome/duotone-light-svg-icons/faCircleUser';
import { faHome as fadHome } from '@fortawesome/duotone-light-svg-icons/faHome';
import { faDna as fadTrial } from '@fortawesome/duotone-light-svg-icons/faDna';
import { faClipboard as fadClipboard } from '@fortawesome/duotone-light-svg-icons/faClipboard';
import { faHospitalAlt as fadInstitution } from '@fortawesome/duotone-light-svg-icons/faHospitalAlt';
import { faUser as fadUser } from '@fortawesome/duotone-light-svg-icons/faUser';
import { faSitemap as fadGroups } from '@fortawesome/duotone-light-svg-icons/faSitemap';
import { faCogs as fadSettings } from '@fortawesome/duotone-light-svg-icons/faCogs';
import { faSearch as fadSearch } from '@fortawesome/duotone-light-svg-icons/faSearch';
import { faCog as fadCog } from '@fortawesome/duotone-light-svg-icons/faCog';
import { faUsers as fadGroup } from '@fortawesome/duotone-light-svg-icons/faUsers';
import { faFileMedicalAlt as fadQa } from '@fortawesome/duotone-light-svg-icons/faFileMedicalAlt';
import { faIdCardAlt as fadOpenClinica, faIdCardAlt } from '@fortawesome/duotone-light-svg-icons/faIdCardAlt';
import { faShapes as fadShapes } from '@fortawesome/duotone-light-svg-icons/faShapes';
import { faUserShield as fadUserShield } from '@fortawesome/duotone-light-svg-icons/faUserShield';
import { faEarthOceania as fadEarthOceania } from '@fortawesome/duotone-light-svg-icons/faEarthOceania';
import { faRouteInterstate as fadRouteInterstate } from '@fortawesome/duotone-light-svg-icons/faRouteInterstate';
import { faListTimeline as fadListTimeline } from '@fortawesome/duotone-light-svg-icons/faListTimeline';
import { faListRadio as fadListRadio } from '@fortawesome/duotone-light-svg-icons/faListRadio';
import { faVenusMars as fadVenusMars } from '@fortawesome/duotone-light-svg-icons/faVenusMars';
import { faStomach as fadStomach } from '@fortawesome/duotone-light-svg-icons/faStomach';
import { faPeopleGroup as fadPeopleGroup } from '@fortawesome/duotone-light-svg-icons/faPeopleGroup';
import { faUserDoctor as fadUserDoctor } from '@fortawesome/duotone-light-svg-icons/faUserDoctor';
import { faPersonHalfDress as fadPersonHalfDress } from '@fortawesome/duotone-light-svg-icons/faPersonHalfDress';
import { faFlag as fadFlag } from '@fortawesome/duotone-light-svg-icons/faFlag';
import { faShieldHalved as fadShieldHalved } from '@fortawesome/duotone-light-svg-icons/faShieldHalved';
import { faRouteHighway as fadRouteHighway } from '@fortawesome/duotone-light-svg-icons/faRouteHighway';
import { faOctagon as fadOctagon } from '@fortawesome/duotone-light-svg-icons/faOctagon';
import { faNote as fadNote } from '@fortawesome/duotone-light-svg-icons/faNote';
import { faMars as fadMars } from '@fortawesome/duotone-light-svg-icons/faMars';
import { faVenus as fadVenus } from '@fortawesome/duotone-light-svg-icons/faVenus';
import { faNeuter as fadNeuter } from '@fortawesome/duotone-light-svg-icons/faNeuter';
import { faMarsAndVenusBurst as fadMarsAndVenusBurst } from '@fortawesome/duotone-light-svg-icons/faMarsAndVenusBurst';
import { faKidneys as fadKidneys } from '@fortawesome/duotone-light-svg-icons/faKidneys';
import { faIdBadge as fadIdBadge } from '@fortawesome/duotone-light-svg-icons/faIdBadge';
import { faStethoscope as fadStethoscope } from '@fortawesome/duotone-light-svg-icons/faStethoscope';
import { faTags as fadTags } from '@fortawesome/duotone-light-svg-icons/faTags';
import { faFolders as fadFolders } from '@fortawesome/duotone-light-svg-icons/faFolders';
import { faFile as fadFile } from '@fortawesome/duotone-light-svg-icons/faFile';
import { faSolarSystem as fadSolarSystem } from '@fortawesome/duotone-light-svg-icons/faSolarSystem';
import { faRadar as fadRadar } from '@fortawesome/duotone-light-svg-icons/faRadar';
import { faStarSharp as fadStarSharp } from '@fortawesome/duotone-light-svg-icons/faStarSharp';
import { faBrain as fadBrain } from '@fortawesome/duotone-light-svg-icons/faBrain';
import { faWonSign as fadWonSign } from '@fortawesome/duotone-light-svg-icons/faWonSign';
import { faTally as fadTally } from '@fortawesome/duotone-light-svg-icons/faTally';
import { faHandDots as fadHandDots } from '@fortawesome/duotone-light-svg-icons/faHandDots';
import { faArrowsToCircle as fadArrowsToCircle } from '@fortawesome/duotone-light-svg-icons/faArrowsToCircle';
import { faPeopleRoof as fadPeopleRoof } from '@fortawesome/duotone-light-svg-icons/faPeopleRoof';
import { faAtomSimple as fadAtomSimple } from '@fortawesome/duotone-light-svg-icons/faAtomSimple';
import { faVirus as fadVirus } from '@fortawesome/duotone-light-svg-icons/faVirus';
import { faWaveformLines as fadWaveformLines } from '@fortawesome/duotone-light-svg-icons/faWaveformLines';
import { faTally2 as fadTally2 } from '@fortawesome/duotone-light-svg-icons/faTally2';
import { faHandshake as fadHandshake } from '@fortawesome/duotone-light-svg-icons/faHandshake';
import { faBuildings as fadBuildings } from '@fortawesome/duotone-light-svg-icons/faBuildings';
import { faPersonMilitaryToPerson as fadPersonMilitaryToPerson } from '@fortawesome/duotone-light-svg-icons/faPersonMilitaryToPerson';
import { faPotato as fadPotato } from '@fortawesome/duotone-light-svg-icons/faPotato';
import { faBuildingFlag as fadBuildingFlag } from '@fortawesome/duotone-light-svg-icons/faBuildingFlag';
import { faAddressBook as fadAddressBook } from '@fortawesome/duotone-light-svg-icons/faAddressBook';
import { faKazoo as fadKazoo } from '@fortawesome/duotone-light-svg-icons/faKazoo';
import { faHouseMedical as fadHouseMedical } from '@fortawesome/duotone-light-svg-icons/faHouseMedical';
import { faCode as fadCode } from '@fortawesome/duotone-light-svg-icons/faCode';
import { faFlagCheckered as fadFlagCheckered } from '@fortawesome/duotone-light-svg-icons/faFlagCheckered';
import { faSimCards as fadSimCards } from '@fortawesome/duotone-light-svg-icons/faSimCards';
import { faNotesMedical as fadNotesMedical } from '@fortawesome/duotone-light-svg-icons/faNotesMedical';
import { faBlanket as fadBlanket } from '@fortawesome/duotone-light-svg-icons/faBlanket';
import { faBarsProgress as fadBarsProgress } from '@fortawesome/duotone-light-svg-icons/faBarsProgress';
import { faWavesSine as fadWavesSine } from '@fortawesome/duotone-light-svg-icons/faWavesSine';
import { faTrophy as fadTrophy } from '@fortawesome/duotone-light-svg-icons/faTrophy';
import { faFiles as fadFiles } from '@fortawesome/duotone-light-svg-icons/faFiles';
import { faInboxes as fadInboxes } from '@fortawesome/duotone-light-svg-icons/faInboxes';
import { faTag as fadTag } from '@fortawesome/duotone-light-svg-icons/faTag';
import { faCandyBar as fadCandyBar } from '@fortawesome/duotone-light-svg-icons/faCandyBar';
import { faWaveSine as fadWaveSine } from '@fortawesome/duotone-light-svg-icons/faWaveSine';
import { faAward as fadAward } from '@fortawesome/duotone-light-svg-icons/faAward';
import { faInboxFull as fadInboxFull } from '@fortawesome/duotone-light-svg-icons/faInboxFull';
import { faLeftToLine as fadLeftToLine } from '@fortawesome/duotone-light-svg-icons/faLeftToLine';
import { faCircleInfo as fadCircleInfo } from '@fortawesome/duotone-light-svg-icons/faCircleInfo';
import { faUsersMedical as fadUsersMedical } from '@fortawesome/duotone-light-svg-icons/faUsersMedical';
import { faMemoPad as fadMemoPad } from '@fortawesome/duotone-light-svg-icons/faMemoPad';
import { faI as fadI } from '@fortawesome/duotone-light-svg-icons/faI';
import { faPenField as fadPenField } from '@fortawesome/duotone-light-svg-icons/faPenField';
import { faUserMagnifyingGlass as fadUserMagnifyingGlass } from '@fortawesome/duotone-light-svg-icons/faUserMagnifyingGlass';
import { faBooksMedical as fadBooksMedical } from '@fortawesome/duotone-light-svg-icons/faBooksMedical';
import { faSendBack as fadSendBack } from '@fortawesome/duotone-light-svg-icons/faSendBack';
import { faDiceOne as fadDiceOne } from '@fortawesome/duotone-light-svg-icons/faDiceOne';
import { faBuilding as fadBuilding } from '@fortawesome/duotone-light-svg-icons/faBuilding';
import { faDungeon as fadDungeon } from '@fortawesome/duotone-light-svg-icons/faDungeon';
import { faExclamation as fadExclamation } from '@fortawesome/duotone-light-svg-icons/faExclamation';
import { faInfo as fadInfo } from '@fortawesome/duotone-light-svg-icons/faInfo';
import { faBookMedical as fadBookMedical } from '@fortawesome/duotone-light-svg-icons/faBookMedical';
import { faUserGroupSimple as fadUserGroupSimple } from '@fortawesome/duotone-light-svg-icons/faUserGroupSimple';
import { faWavePulse as fadWavePulse } from '@fortawesome/duotone-light-svg-icons/faWavePulse';
import { faComments as fadComments } from '@fortawesome/duotone-light-svg-icons/faComments';
import { faRampLoading as fadRampLoading } from '@fortawesome/duotone-light-svg-icons/faRampLoading';
import { faHouseChimney as fadHouseChimney } from '@fortawesome/duotone-light-svg-icons/faHouseChimney';
import { faReceipt as fadReceipt } from '@fortawesome/duotone-light-svg-icons/faReceipt';
import { faSparkles as fadSparkles } from '@fortawesome/duotone-light-svg-icons/faSparkles';
import { faFileImport as fadFileImport } from '@fortawesome/duotone-light-svg-icons/faFileImport';
import { faCalendarCircleUser as fadCalendarCircleUser } from '@fortawesome/duotone-light-svg-icons/faCalendarCircleUser';
import { faGroupArrowsRotate as fadGroupArrowsRotate } from '@fortawesome/duotone-light-svg-icons/faGroupArrowsRotate';
import { faCircleR as fadCircleR } from '@fortawesome/duotone-light-svg-icons/faCircleR';
import { faFileCertificate as fadFileCertificate } from '@fortawesome/duotone-light-svg-icons/faFileCertificate';
import { faBuildingShield as fadBuildingShield } from '@fortawesome/duotone-light-svg-icons/faBuildingShield';
import { faBlock as fadBlock } from '@fortawesome/duotone-light-svg-icons/faBlock';
import { faDiceD20 as fadDiceD20 } from '@fortawesome/duotone-light-svg-icons/faDiceD20';
import { faBuildingMemo as fadBuildingMemo } from '@fortawesome/duotone-light-svg-icons/faBuildingMemo';
import { faSquarePlus as fadSquarePlus } from '@fortawesome/duotone-light-svg-icons/faSquarePlus';
import { faArrowUpToLine as fadArrowUpToLine } from '@fortawesome/duotone-light-svg-icons/faArrowUpToLine';
import { faArrowDownToLine as fadArrowDownToLine } from '@fortawesome/duotone-light-svg-icons/faArrowDownToLine';
import { faSquareCheck as fadSquareCheck } from '@fortawesome/duotone-light-svg-icons/faSquareCheck';
import { faHandHoldingHeart as fadHandHoldingHeart } from '@fortawesome/duotone-light-svg-icons/faHandHoldingHeart';
import { faScaleBalanced as fadScaleBalanced } from '@fortawesome/duotone-light-svg-icons/faScaleBalanced';
import { faEye as fadEye } from '@fortawesome/duotone-light-svg-icons/faEye';
import { faHospitals as fadHospitals } from '@fortawesome/duotone-light-svg-icons/faHospitals';
import { faDisplayMedical as fadDisplayMedical } from '@fortawesome/duotone-light-svg-icons/faDisplayMedical';
import { faBuildingColumns as fadBuildingColumns } from '@fortawesome/duotone-light-svg-icons/faBuildingColumns';
import { faFileContract as fadFileContract } from '@fortawesome/duotone-light-svg-icons/faFileContract';
import { faMoneyCheckDollarPen as fadMoneyCheckDollarPen } from '@fortawesome/duotone-light-svg-icons/faMoneyCheckDollarPen';
import { faUsersViewfinder as fadUsersViewfinder } from '@fortawesome/duotone-light-svg-icons/faUsersViewfinder';
import { faBoothCurtain as fadBoothCurtain } from '@fortawesome/duotone-light-svg-icons/faBoothCurtain';
import { faClipboardUser as fadClipboardUser } from '@fortawesome/duotone-light-svg-icons/faClipboardUser';
import { faChartLine as fadChartLine } from '@fortawesome/duotone-light-svg-icons/faChartLine';
import { faFlaskVial as fadFlaskVial } from '@fortawesome/duotone-light-svg-icons/faFlaskVial';
import { faBuildingWheat as fadBuildingWheat } from '@fortawesome/duotone-light-svg-icons/faBuildingWheat';
import { faCalendarAlt as fadCalendarAltDuo } from '@fortawesome/duotone-light-svg-icons/faCalendarAlt';
import { faComment as fadComment } from '@fortawesome/duotone-light-svg-icons/faComment';
import { faTrash as fadTrash } from '@fortawesome/duotone-light-svg-icons/faTrash';
import { faIdCardAlt as fadRole } from '@fortawesome/duotone-light-svg-icons/faIdCardAlt';
import { faGlobe as fadGlobe } from '@fortawesome/duotone-light-svg-icons/faGlobe';
import { faUserUnlock as fadUserUnlock } from '@fortawesome/duotone-light-svg-icons/faUserUnlock';
import { faRightLeftLarge as fadRightLeftLarge } from '@fortawesome/duotone-light-svg-icons/faRightLeftLarge';
import { faGlobePointer as fadGlobePointer } from '@fortawesome/duotone-light-svg-icons/faGlobePointer';
import { faArrowUpRightFromSquare as fadArrowUpRightFromSquare } from '@fortawesome/duotone-light-svg-icons/faArrowUpRightFromSquare';
import { faBook as fadBook } from '@fortawesome/duotone-light-svg-icons/faBook';
import { faBookOpen as fadBookOpen } from '@fortawesome/duotone-light-svg-icons/faBookOpen';
import { faSignature as fadSignature } from '@fortawesome/duotone-light-svg-icons/faSignature';
import { faHouseMedicalFlag as fadHouseMedicalFlag } from '@fortawesome/duotone-light-svg-icons/faHouseMedicalFlag';
import { faNetworkWired as fadNetworkWired } from '@fortawesome/duotone-light-svg-icons/faNetworkWired';
import { faMoon as fadMoon } from '@fortawesome/duotone-light-svg-icons/faMoon';
import { faSun as fadSun } from '@fortawesome/duotone-light-svg-icons/faSun';
import { faSquareCode as fadSquareCode } from '@fortawesome/duotone-light-svg-icons/faSquareCode';
import { faRectangleBarcode as fadRectangleBarcode } from '@fortawesome/duotone-light-svg-icons/faRectangleBarcode';
import { faMonitorWaveform as fadMonitorWaveform } from '@fortawesome/duotone-light-svg-icons/faMonitorWaveform';
import { faCardDiamond as fadCardDiamond } from '@fortawesome/duotone-light-svg-icons/faCardDiamond';
import { faCircleQuestion as fadCircleQuestion } from '@fortawesome/duotone-light-svg-icons/faCircleQuestion';

import { FontAwesomeIcon as FontAwesomeIconApi } from '@fortawesome/react-fontawesome';
export const FontAwesomeIcon = FontAwesomeIconApi;

export const FontAwesomeIcons = {
    Light: {
        USER: falUser,
        USEREDIT: falUserEdit,
        INFO_CIRCLE: falInfoCircle,
        TRASH: falTrash,
        UP: faChevronUp,
        DOWN: faChevronDown,
        LEFT: faChevronLeft,
        RIGHT: faChevronRight,
        CHECK: falSquareCheck,
        UNCHECKED: falSquare,
        INSTITUTION: falInstitution,
        TRIALINSTITUTION: falTrialInstitution,
        TRIAL: falTrial,
        SETTINGS: falSettings,
        ROLE: falRole,
        NOTE: falNote,
        GROUP: falGroup,
        TRIALITEM: falTrialItem,
        LOOKUP: falLookup,
        ITEMCOLLECTION: falItemCollection,
        EMAIL: faEnvelope,
        EDIT: falEdit,
        HOME: falHome,
        IDBADGE: falIdBadge,
        PAPERCLIP: falPaperClip,
        CHEVRONRIGHT: falChevronRight,
        PENFIELD: falPenField,
        FILEARROWDOWN: falFileArrowDown,
        FILEARROWUP: falFileArrowUp,
        SQUARE: falSquare,
        DASH: falDash
    },
    Regular: {
        USER: farUser,
        USEREDIT: farUserEdit,
        TIMES: farTimes,
        CHECK: farCheck,
        QUESTION: farQuestion,
        HAND_POINT_RIGHT: farHandPointRight,
        SEARCH: farSearch,
        CLOCK: farClock,
        STAR: farStar,
        TIMES_CIRCLE: farTimesCircle,
        TAG: farTag,
        CLIPBOARD: farClipboard,
        REPEAT: farRepeat
    },
    Solid: {
        USER: fasUser,
        USEREDIT: fasUserEdit,
        CIRCLE: fasCircle,
        QUESTION: fasQuestion,
        SQUARE: fasSquare,
        ANGLE_UP: fasAngleUp,
        ANGLE_DOWN: fasAngleDown,
        ANGLE_LEFT: fasAngleLeft,
        ANGLE_RIGHT: fasAngleRight,
        BUILDING: fasBuilding,
        EYE: fasEye,
        INFO_SQUARE: fasInfoSquare,
        INFO_CIRCLE: fasInfoCircle,
        FILE: fasFile,
        FILE_ALT: fasFileAlt,
        CALENDAR_ALT: fasCalendarAlt,
        MEDKIT: fasMedKit,
        EXCLAMATION_CIRCLE: fasExclamationCircle,
        EXCLAMATION_TRIANGLE: fasExclamationTriangle,
        TIMES_OCTAGON: fasTimesOctagon,
        CHECK: fasCheck,
        TRUCK: fasTruck,
        CLIPBOARD: fasClipboard,
        HEARTBEAT: fasHeartbeat,
        FLASK: fasFlask,
        PLUS: fasPlus,
        SIGN_IN: fasSignIn,
        SIGN_OUT: fasSignOut,
        VIAL: fasVial,
        VIALS: fasVials,
        CLOUD_UPLOAD: fasCloudUpload,
        CLOUD_DOWNLOAD: fasCloudDownload,
        SEARCH: fasSearch,
        BAN: fasBan,
        LIST: fasList,
        COGS: fasCogs,
        ASTERISK: fasAsterisk,
        HAMBURGER: fasHamburger,
        COG: fasCog,
        PROJECT: fasProjectDiagram,
        TRIAL: fasTrial,
        GROUP: fasGroup,
        INSTITUTION: fasInstitution,
        QA: fasQa,
        OPENCLINICA: fasOpenClinica,
        CHEVRONRIGHT: fasChevronRight,
        CHEVRONLEFT: fasChevronLeft,
        TRIANGLE: fasTriangle,
        CARETDOWN: fasCaretDown,
        DASH: fasDash
    },
    Duotone: {
        CIRCLEUSER: fadCircleUser,
        HOME: fadHome,
        TRIAL: fadTrial,
        CLIPBOARD: fadClipboard,
        INSTITUTION: fadInstitution,
        USER: fadUser,
        GROUP: fadGroups,
        SETTINGS: fadSettings,
        SEARCH: fadSearch,
        COG: fadCog,
        COMMITTEE: fadGroup,
        QA: fadQa,
        OPENCLINICA: fadOpenClinica,
        SHAPES: fadShapes,
        USERSHIELD: fadUserShield,
        EARTHOCEANIA: fadEarthOceania,
        ROUTEINTERSTATE: fadRouteInterstate,
        LISTTIMELINE: fadListTimeline,
        LISTRADIO: fadListRadio,
        VENUSMARS: fadVenusMars,
        STOMACH: fadStomach,
        PEOPLEGROUP: fadPeopleGroup,
        USERDOCTOR: fadUserDoctor,
        PERSONHALFDRESS: fadPersonHalfDress,
        FLAG: fadFlag,
        SHIELDHALVED: fadShieldHalved,
        ROUTEHIGHWAY: fadRouteHighway,
        OCTAGON: fadOctagon,
        NOTE: fadNote,
        MARS: fadMars,
        VENUS: fadVenus,
        NEUTER: fadNeuter,
        MARSANDVENUSBURST: fadMarsAndVenusBurst,
        KIDENEYS: fadKidneys,
        IDBADGE: fadIdBadge,
        STETHOSCOPE: fadStethoscope,
        TAGS: fadTags,
        FOLDERS: fadFolders,
        FILE: fadFile,
        SOLARSYSTEM: fadSolarSystem,
        RADAR: fadRadar,
        STARSHARP: fadStarSharp,
        BRAIN: fadBrain,
        WONSIGN: fadWonSign,
        TALLY: fadTally,
        HANDDOTS: fadHandDots,
        ARROWSTOCIRCLE: fadArrowsToCircle,
        PEOPLEROOF: fadPeopleRoof,
        ATOMSIMPLE: fadAtomSimple,
        VIRUS: fadVirus,
        WAVEFORMLINES: fadWaveformLines,
        TALLY2: fadTally2,
        HANDSHAKE: fadHandshake,
        BUILDINGS: fadBuildings,
        PERSONMILITARYTOPERSON: fadPersonMilitaryToPerson,
        POTATO: fadPotato,
        BUILDINGFLAG: fadBuildingFlag,
        ADDRESSBOOK: fadAddressBook,
        KAZOO: fadKazoo,
        HOUSEMEDICAL: fadHouseMedical,
        CODE: fadCode,
        FLAGCHECKERED: fadFlagCheckered,
        SIMCARDS: fadSimCards,
        NOTESMEDICAL: fadNotesMedical,
        BLANKET: fadBlanket,
        BARSPROGRESS: fadBarsProgress,
        WAVESSINE: fadWavesSine,
        TROPHY: fadTrophy,
        FILES: fadFiles,
        INBOXES: fadInboxes,
        TAG: fadTag,
        CANDYBAR: fadCandyBar,
        WAVESINE: fadWaveSine,
        AWARD: fadAward,
        INBOXFULL: fadInboxFull,
        LEFTTOLINE: fadLeftToLine,
        CIRCLEINFO: fadCircleInfo,
        USERSMEDICAL: fadUsersMedical,
        MEMOPAD: fadMemoPad,
        I: fadI,
        PENFIELD: fadPenField,
        USERMAGNIFYINGGLASS: fadUserMagnifyingGlass,
        BOOKSMEDICAL: fadBooksMedical,
        SENDBACK: fadSendBack,
        DICEONE: fadDiceOne,
        BUILDING: fadBuilding,
        DUNGEON: fadDungeon,
        EXCLAMATION: fadExclamation,
        INFO: fadInfo,
        BOOKMEDICAL: fadBookMedical,
        USERGROUPSIMPLE: fadUserGroupSimple,
        WAVEPULSE: fadWavePulse,
        COMMENTS: fadComments,
        RAMPLOADING: fadRampLoading,
        HOUSECHIMNEY: fadHouseChimney,
        RECEIPT: fadReceipt,
        SPARKLES: fadSparkles,
        FILEIMPORT: fadFileImport,
        CALENDARCIRCLEUSER: fadCalendarCircleUser,
        GROUPARROWSROTATE: fadGroupArrowsRotate,
        CIRCLER: fadCircleR,
        FILECERTIFICATE: fadFileCertificate,
        BUILDINGSHIELD: fadBuildingShield,
        BLOCK: fadBlock,
        DICED20: fadDiceD20,
        BUILDINGMEMO: fadBuildingMemo,
        SQUAREPLUS: fadSquarePlus,
        ARROWUPTOLINE: fadArrowUpToLine,
        ARROWDOWNTOLINE: fadArrowDownToLine,
        SQUARECHECK: fadSquareCheck,
        HANDHOLDINGHEART: fadHandHoldingHeart,
        SCALEBALANCED: fadScaleBalanced,
        EYE: fadEye,
        HOSPITALS: fadHospitals,
        DISPLAYMEDICAL: fadDisplayMedical,
        BULIDINGCOLUMNS: fadBuildingColumns,
        FILECONTRACT: fadFileContract,
        MONEYCHECKDOLLARPEN: fadMoneyCheckDollarPen,
        USERSVIEWFINDER: fadUsersViewfinder,
        BOOTHCURTAIN: fadBoothCurtain,
        CLIPBOARDUSER: fadClipboardUser,
        CHARTLINE: fadChartLine,
        FLASKVIAL: fadFlaskVial,
        BUILDINGWHEAT: fadBuildingWheat,
        CALENDARALT: fadCalendarAltDuo,
        COMMENT: fadComment,
        TRASH: fadTrash,
        ROLE: faIdCardAlt,
        GLOBE: fadGlobe,
        USERUNLOCK: fadUserUnlock,
        RIGHTLEFTLARGE: fadRightLeftLarge,
        GLOBEPOINTER: fadGlobePointer,
        ARROWUPRIGHTFROMSQUARE: fadArrowUpRightFromSquare,
        BOOK: fadBook,
        BOOKOPEN: fadBookOpen,
        SIGNATURE: fadSignature,
        TRIALINSTITUTION: fadHouseMedicalFlag,
        TRIALGROUP: fadNetworkWired,
        MOON: fadMoon,
        SUN: fadSun,
        SQUARECODE: fadSquareCode,
        RECTANGLEBARCODE: fadRectangleBarcode,
        MONITOR: fadMonitorWaveform,
        MONITORINGISSUE: fadCardDiamond,
        CIRCLEQUESTION: fadCircleQuestion
    },
};